import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
    bank: environment.apiBankUrl, 
    pgl: environment.apiPglUrl,
    smt: environment.apiSmtUrl,
  };
  private getBaseUrl(userType: 'bank' | 'pgl' | 'smt'): string {
    const baseUrl = this.apiUrls[userType??'smt']+'/users/';
    if (!baseUrl) {
      throw new Error(`Invalid userType: ${userType}`);
    }
    return baseUrl;
  }
  public userrole$ = new BehaviorSubject<string>('');
  constructor(private router: Router, private http: HttpClient) {}
  register(email:string,password:string,confirmpassword:string,usertype:string, mobile:string,firstname:string,lastname:string,clientcode: string,role:string,banque:string, userType: 'bank' | 'pgl' | 'smt'):Observable<any> {
    const baseUrl = this.getBaseUrl(userType);
    return this.http.post(baseUrl + 'signup', {
      email, password, confirmpassword,firstname, lastname,usertype,mobile,clientcode, role,banque
    }, httpOptions);

  }
  registersuperadmin(email:string,password:string,banque:string,confirmpassword:string,usertype:string,firstname:string,lastname:string,clientcode: string,role:string, userType: 'bank' | 'pgl' | 'smt'):Observable<any> {
    const baseUrl = this.getBaseUrl(userType);
    return this.http.post(baseUrl + 'signupsuperadmin', {
      email, password, confirmpassword,firstname, lastname,usertype,clientcode, role,banque,
    }, httpOptions);

  }
  registeradminbanque(email:string,carte:string,affiliation:string,banque:string,indicatifagence:string,terminal:string,password:string,confirmpassword:string,usertype:string,firstname:string,lastname:string,clientcode: string,role:string,compte:string, userType: 'bank' | 'pgl' | 'smt'):Observable<any> {
    const baseUrl = this.getBaseUrl(userType);
    return this.http.post(baseUrl + 'signupadminbanque', {
      email, password, confirmpassword,firstname, lastname,usertype,clientcode, role,carte,affiliation,banque,indicatifagence,terminal,compte
    }, httpOptions);

  }
  registeradmincomite(email:string,carte:string,affiliation:string,banque:string,indicatifagence:string,terminal:string,password:string,confirmpassword:string,usertype:string,firstname:string,lastname:string,clientcode: string,role:string,compte:string, userType: 'bank' | 'pgl' | 'smt'):Observable<any> {
    const baseUrl = this.getBaseUrl(userType);
    return this.http.post(baseUrl + 'signupadmincomite', {
      email, password, confirmpassword,firstname, lastname,usertype,clientcode, role,carte,affiliation,banque,indicatifagence,terminal,compte
    }, httpOptions);

  }
  login(email: string, password: string, userType: 'bank' | 'pgl' | 'smt'): Observable<any> {
    const baseUrl = this.getBaseUrl(userType);

    return this.http.post(baseUrl + 'login', {
      email,
      password
    }, httpOptions);
  
  }
  private getUserType(): 'bank' | 'pgl' | 'smt' {
    const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
    if (!token) return 'smt';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.type as 'bank' | 'pgl' | 'smt';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'smt';
    }
  }
  }
